import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import moment from "moment";

export async function exportStudentInvoiceHistoryExcel({
  historyData = [],
  studentName = "",
  studentCode = "",
  title = "LỊCH SỬ PHIẾU THU HỌC SINH"
}) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'OneKids';
  workbook.lastModifiedBy = 'OneKids';
  workbook.created = new Date();
  
  const worksheet = workbook.addWorksheet('LichSuPhieuThu');

  const rowTitle = worksheet.addRow([title]);
  rowTitle.height = 30;
  rowTitle.getCell(1).font = { name: 'Times New Roman', bold: true, size: 16 };
  rowTitle.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
  
  worksheet.addRow([`Học sinh: ${studentName} - Mã HS: ${studentCode}`]);
  worksheet.getRow(2).getCell(1).font = { name: 'Times New Roman', bold: true, size: 12 };
  
  worksheet.addRow([]); // empty row

  const headers = [
    "STT", 
    "Tháng-Năm", 
    "Đợt", 
    "Mã phiếu thu", 
    "Tên lớp/nhóm",
    "Thiếu/Thừa phiếu thu trước",
    "Phải thu",
    "Đã thu",
    "Tiền mặt",
    "Chuyển khoản",
    "Thiếu/Thừa còn lại"
  ];

  worksheet.mergeCells(1, 1, 1, headers.length);
  worksheet.mergeCells(2, 1, 2, headers.length);

  const headerRow = worksheet.addRow(headers);
  headerRow.height = 32;
  headerRow.eachCell((cell) => {
    cell.font = { name: 'Times New Roman', bold: true, size: 11 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' }, left: { style: 'thin' },
      bottom: { style: 'thin' }, right: { style: 'thin' }
    };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
  });

  worksheet.columns = headers.map((header, index) => {
    let width = 12;
    if (index === 1) width = 15; // Tháng năm
    else if (index === 2) width = 10; // Đợt
    else if (index === 3) width = 18; // Mã phiếu thu
    else if (index === 4) width = 20; // Tên lớp/nhóm
    else if (index === 5) width = 26; // Thiếu/Thừa phiếu thu trước
    else if (index >= 5) width = 18; // Cột tiền
    else width = 8; // STT
    return { width };
  });

  const totals = new Array(headers.length).fill("");
  totals[1] = "Tổng cộng";

  const addToTotal = (index, value) => {
      if (value !== "" && value !== null && value !== undefined) {
          const num = Number(value);
          if (!isNaN(num)) {
              if (totals[index] === "") totals[index] = 0;
              totals[index] += num;
          }
      }
  };

  historyData.forEach((item, index) => {
    const rowData = [
      index + 1,
      `${item.month}/${item.year}`,
      item.turn || "",
      item.invoiceCode || "—",
      item.targetName || "—",
      item.beforeMoney || 0,
      item.sumMoney || 0,
      item.collectedMoney || 0,
      item.cashMoney || 0,
      item.transferMoney || 0,
      item.afterMoney || 0
    ];

    // Cột tiền bắt đầu từ index 5 (0-based)
    for (let i = 5; i < 11; i++) {
        addToTotal(i, rowData[i]);
    }

    const row = worksheet.addRow(rowData);
    row.eachCell((cell, colNumber) => {
      cell.font = { name: 'Times New Roman', size: 11 };
      cell.border = {
        top: { style: 'thin' }, left: { style: 'thin' },
        bottom: { style: 'thin' }, right: { style: 'thin' }
      };
      
      const colIdx = colNumber - 1;
      
      if (colIdx >= 0 && colIdx <= 4) {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      } else {
        cell.alignment = { horizontal: 'right', vertical: 'middle' };
        if (typeof cell.value === "number") cell.numFmt = '#,##0';
      }
    });
  });

  if (historyData.length > 0) {
      const totalRow = worksheet.addRow(totals);
      totalRow.eachCell((cell, colNumber) => {
          cell.font = { name: 'Times New Roman', bold: true, size: 11 };
          cell.border = {
            top: { style: 'thin' }, left: { style: 'thin' },
            bottom: { style: 'thin' }, right: { style: 'thin' }
          };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } }; // Light grey
          
          const colIdx = colNumber - 1;
          
          if (colIdx >= 0 && colIdx <= 4) {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          } else {
            cell.alignment = { horizontal: 'right', vertical: 'middle' };
            if (typeof cell.value === "number") cell.numFmt = '#,##0';
          }
      });
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const timeStamp = moment().format('YYYYMMDD_HHmmss');
  saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Lich_Su_Phieu_Thu_${timeStamp}.xlsx`);
}
